import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'plural',
    standalone: false
})
export class PluralPipe implements PipeTransform {
  transform(label: string, quantity: number): string {
    if (!quantity || !label || label.length === 0) { return null; }
    return quantity > 1 && label[label.length - 1] !== 's' ? (label + 's') : label;
  }
}
